/* ==========================================================================
   Outlet4IT — Collection page
   <o4-collection>: AJAX filtering + sorting (Section Rendering API),
   mobile filter drawer, browser history sync.
   ========================================================================== */
(function () {
  'use strict';

  class O4Collection extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.form      = this.querySelector('[data-filter-form]');
      this.sortSel   = this.querySelector('[data-sort]');
      this.sidebar   = this.querySelector('[data-sidebar]');
      this.backdrop  = this.querySelector('[data-backdrop]');
      this.toggle    = this.querySelector('[data-filter-open]');
      this.grid      = this.querySelector('[data-grid]');
      this.desktop   = window.matchMedia('(min-width: 990px)');
      this._priceTimer = null;

      this._bind();
      if (!this.desktop.matches && this.sidebar) this.sidebar.inert = true;
    }

    _bind() {
      var self = this;

      if (this.form) {
        this.form.addEventListener('change', function (e) {
          // Ignore UI-only checkboxes (e.g. the "Mehr anzeigen" toggle has no name)
          if (e.target.type === 'checkbox' && e.target.name) self._render(self._url());
        });
        this.form.addEventListener('input', function (e) {
          if (e.target.type === 'number') {
            clearTimeout(self._priceTimer);
            self._priceTimer = setTimeout(function () { self._render(self._url()); }, 650);
          }
        });
        this.form.addEventListener('submit', function (e) { e.preventDefault(); self._render(self._url()); });
      }

      if (this.sortSel) {
        this.sortSel.addEventListener('change', function () { self._render(self._url()); });
      }

      /* Active-filter chip + clear links → AJAX */
      this.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-remove]');
        if (rm) { e.preventDefault(); self._render(rm.getAttribute('href')); }
      });

      /* Quick add-to-cart on product cards (delegated → survives re-renders) */
      this.addEventListener('click', function (e) {
        var add = e.target.closest('[data-cart-add]');
        if (add) { e.preventDefault(); self._quickAdd(add); }
      });

      /* Drawer */
      if (this.toggle) this.toggle.addEventListener('click', function () { self._openDrawer(); });
      this.querySelectorAll('[data-filter-close]').forEach(function (b) {
        b.addEventListener('click', function () { self._closeDrawer(); });
      });
      if (this.backdrop) this.backdrop.addEventListener('click', function () { self._closeDrawer(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self._drawerOpen()) self._closeDrawer();
      });

      window.addEventListener('popstate', function () {
        self._render(window.location.pathname + window.location.search, false);
      });

      this.desktop.addEventListener('change', function (e) {
        if (self.sidebar) self.sidebar.inert = e.matches ? false : !self._drawerOpen();
      });
    }

    /* ── Quick add-to-cart ─────────────────────────────────────────────── */
    _root() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    }

    _quickAdd(btn) {
      var self = this;
      var id = btn.getAttribute('data-variant-id');
      if (!id || btn.classList.contains('is-loading')) return;
      btn.classList.remove('is-added', 'is-error');
      btn.classList.add('is-loading');

      fetch(this._root() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          btn.classList.remove('is-loading');
          if (!res.ok) { self._flash(btn, 'is-error'); return; }
          self._flash(btn, 'is-added');
          self._updateCartCount();
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          self._flash(btn, 'is-error');
        });
    }

    _flash(btn, cls) {
      btn.classList.add(cls);
      setTimeout(function () { btn.classList.remove(cls); }, 1600);
    }

    _updateCartCount() {
      fetch(this._root() + 'cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.o4-header__cart-count').forEach(function (el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? '' : 'none';
          });
          var cartLink = document.querySelector('.o4-header__cart');
          if (cartLink && !cartLink.querySelector('.o4-header__cart-count') && cart.item_count > 0) {
            var span = document.createElement('span');
            span.className = 'o4-header__cart-count';
            span.textContent = cart.item_count;
            cartLink.appendChild(span);
          }
        })
        .catch(function () {});
    }

    _url() {
      var params = new URLSearchParams();
      var sort = this.sortSel ? this.sortSel.value : null;
      if (sort) params.set('sort_by', sort);
      if (this.form) {
        var fd = new FormData(this.form);
        var entries = fd.entries();
        var step = entries.next();
        while (!step.done) {
          var k = step.value[0], v = step.value[1];
          if (k !== 'sort_by' && v !== '') params.append(k, v);
          step = entries.next();
        }
      }
      var qs = params.toString();
      return window.location.pathname + (qs ? '?' + qs : '');
    }

    _render(url, push) {
      if (push === undefined) push = true;
      var self = this;
      if (this.grid) { this.grid.classList.add('is-loading'); this.grid.setAttribute('aria-busy', 'true'); }

      var sep = url.indexOf('?') === -1 ? '?' : '&';
      fetch(url + sep + 'section_id=' + this.sectionId, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-grid]', '[data-active-filters]', '[data-count]', '[data-pagination]', '[data-filters-inner]']
            .forEach(function (sel) { self._swap(sel, doc); });
          if (push) window.history.pushState({ url: url }, '', url);
          if (!self.desktop.matches) {
            self._closeDrawer();
            var top = self.querySelector('[data-grid]');
            if (top) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        })
        .catch(function (err) { console.error('[O4Collection]', err); })
        .then(function () {
          if (self.grid) { self.grid.classList.remove('is-loading'); self.grid.setAttribute('aria-busy', 'false'); }
        });
    }

    _swap(selector, doc) {
      var live = this.querySelector(selector);
      var next = doc.querySelector(selector);
      if (live && next) live.innerHTML = next.innerHTML;
      /* keep cached grid reference fresh */
      if (selector === '[data-grid]') this.grid = this.querySelector('[data-grid]');
    }

    _drawerOpen() { return this.sidebar && this.sidebar.classList.contains('is-open'); }

    _openDrawer() {
      if (!this.sidebar) return;
      this.sidebar.classList.add('is-open');
      this.sidebar.inert = false;
      if (this.backdrop) this.backdrop.classList.add('is-visible');
      if (this.toggle) this.toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = this.sidebar.querySelector('button, input, a[href]');
      if (first) first.focus();
    }

    _closeDrawer() {
      if (!this.sidebar) return;
      this.sidebar.classList.remove('is-open');
      if (this.backdrop) this.backdrop.classList.remove('is-visible');
      if (this.toggle) { this.toggle.setAttribute('aria-expanded', 'false'); this.toggle.focus(); }
      document.body.style.overflow = '';
      var self = this;
      setTimeout(function () {
        if (!self._drawerOpen() && !self.desktop.matches) self.sidebar.inert = true;
      }, 250);
    }
  }
  customElements.define('o4-collection', O4Collection);

  /* ────────────────────────────────────────────────────────────────────────
     Dual-handle price slider — syncs with the From/To number inputs.
     Range thumbs carry no `name`, so only the number inputs submit to the form.
  ──────────────────────────────────────────────────────────────────────── */
  class O4PriceRange extends HTMLElement {
    connectedCallback() {
      this.minNum = this.querySelector('[data-price-min]');
      this.maxNum = this.querySelector('[data-price-max]');
      this.minR   = this.querySelector('[data-range-min]');
      this.maxR   = this.querySelector('[data-range-max]');
      this.fill   = this.querySelector('[data-range-fill]');
      if (!this.minNum || !this.maxNum || !this.minR || !this.maxR) return;

      this.ceil = this._n(this.maxNum.getAttribute('max'), 100);
      var step = Math.max(1, Math.round(this.ceil / 100));
      this.minR.min = this.maxR.min = 0;
      this.minR.max = this.maxR.max = this.ceil;
      this.minR.step = this.maxR.step = step;
      this.minR.value = this._n(this.minNum.value, 0);
      this.maxR.value = this._n(this.maxNum.value, this.ceil);
      this._fillBar();

      this.minR.addEventListener('input', this._fromRange.bind(this, 'min'));
      this.maxR.addEventListener('input', this._fromRange.bind(this, 'max'));
      this.minNum.addEventListener('input', this._fromNum.bind(this));
      this.maxNum.addEventListener('input', this._fromNum.bind(this));
    }

    _n(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }

    _fromRange(which) {
      var lo = parseFloat(this.minR.value), hi = parseFloat(this.maxR.value);
      if (lo > hi) {
        if (which === 'min') { lo = hi; this.minR.value = lo; }
        else { hi = lo; this.maxR.value = hi; }
      }
      /* Leave inputs blank at the extremes so we don't over-constrain the query */
      this.minNum.value = lo <= 0 ? '' : Math.round(lo);
      this.maxNum.value = hi >= this.ceil ? '' : Math.round(hi);
      this._fillBar();
      var target = which === 'min' ? this.minNum : this.maxNum;
      target.dispatchEvent(new Event('input', { bubbles: true }));
    }

    _fromNum() {
      this.minR.value = this._n(this.minNum.value, 0);
      this.maxR.value = this._n(this.maxNum.value, this.ceil);
      this._fillBar();
    }

    _fillBar() {
      var lo = parseFloat(this.minR.value), hi = parseFloat(this.maxR.value);
      this.fill.style.left = (lo / this.ceil * 100) + '%';
      this.fill.style.right = (100 - (hi / this.ceil * 100)) + '%';
    }
  }
  customElements.define('o4-price-range', O4PriceRange);
})();
